export default {
      id: "ic-nav-chevron-top-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-nav-chevron-top-usage",
      toString: function () {
        return this.url;
      }
    }